import { MoreOutlined } from "@ant-design/icons";
import { Button, InputNumber, Typography } from "antd";
import styled from "styled-components";

import { SecondaryText } from "@/components/Typography/Styled";

export const StyledODTableRow = styled.div`
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};

    &:first-child {
        padding-top: 0px;
    }

    &:last-child {
        padding-bottom: 0px;
        border-bottom: none;
    }
`;

export const StyledODTableRowTop = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    justify-content: space-between;
`;

export const StyledODTableRowTopLeft = styled.div``;

export const StyledODTableRowName = styled(SecondaryText)`
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
`;

export const StyledODTableRowSecondaryText = styled(SecondaryText)`
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    color: ${(props) => props.theme.shelfValueColor} !important;
`;

export const StyledODTableRowSecondaryLabel = styled.span`
    font-weight: 400;
`;

export const StyledODTableRowTopRight = styled.div``;

export const StyledODTableRowController = styled(MoreOutlined)`
    cursor: pointer;
    color: ${(props) => props.theme.secondaryTypographyColor};
    font-size: 24px;
`;

export const StyledODTableRowBottom = styled.div`
    margin-top: 6px;
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr;
    align-items: center;
`;

export const StyledODTableRowMoney = styled(SecondaryText)`
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    color: ${(props) => props.theme.additionalTypographyColor} !important;
`;

export const StyledODTableRowCountBlock = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`;

interface IStyledNumberInput {
    onInput: (value: number) => void;
    isError: boolean;
}

export const StyledODNumberInput = styled(InputNumber)<IStyledNumberInput>`
    max-width: 65px;
    min-width: 65px;
    background-color: ${(props) =>
        props.isError
            ? "rgba(191, 46, 45, 0.3) !important"
            : props.theme.collapseHeaderBackground};
    border-color: ${(props) =>
        props.isError
            ? `${props.theme.dangerTypographyColor} !important`
            : props.theme.secondaryBorderColor};
    input {
        text-align: center !important;
    }
    touch-action: manipulation;
`;

export const StyledODIgnoreStockButton = styled(Button)`
    background-color: ${(props) => props.theme.additionalTypographyColor};
    touch-action: manipulation;
`;

export const StyledODIgnoreStockWrapper = styled.div`
    display: flex;
    margin-top: 8px;
    justify-content: center;
`;

export const StyledODProductBarcode = styled(Typography)`
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    color: ${(props) => props.theme.shelfValueColor} !important;
    border-bottom: 1px dashed ${(props) => props.theme.shelfValueColor};
`;
